import * as yup from 'yup';

import { errorMessages } from '~/constants/errorMessages.js';
import {
  isCounterpartyCodeLengthValid,
  normalizeSearchCode,
} from '~/modules/covenants/CovenantsDataForm/CovenantsFormByClient/utils.ts';

export const buildCounterpartyValidationSchema = () =>
  yup.object({
    searchCode: yup
      .mixed()
      .transform((_, originalValue) => normalizeSearchCode(originalValue))
      .test('search-code-format', errorMessages.INVALID_INPUT_DATA, (value) => {
        const normalizedCode = normalizeSearchCode(value);
        return isCounterpartyCodeLengthValid(normalizedCode);
      }),
  });
